import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateTasks = document.createElement('template');

templateTasks.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <style>${styleHelpersStyles}</style>

  <header class="page__header">
    <gz-title fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}'></gz-title>
  </header>

  <gz-grid-view>
    <div class="header__actions" slot="grid-header-actions-slot">
      <gz-button id="retryBtn" color="primary" buttonfontsize="medium" class="mr-2" disabled></gz-button>
      <gz-button id="actionDelete" type="outline" color="negative" buttonfontsize="medium" disabled></gz-button>
    </div>
  </gz-grid-view>

  <gz-network-sub-tasks class="network-sub-tasks"></gz-network-sub-tasks>
`;
